import axios from "axios";
import { getSession } from "../Utils/SessionUtils";

const api_url = process.env.REACT_APP_API;

const getConfig = () => {
  const token = getSession("token");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
};

export async function getClientsByOrganisation(organisationId) {
  return axios.get(
    api_url + `clients/organisation/${organisationId}`,
    getConfig(),
  );
}

export async function getDefaultClientByOrganisation(organisationId) {
  return axios.get(
    api_url + `clients/organisation/${organisationId}/default`,
    getConfig(),
  );
}

export async function getClientById(id) {
  return axios.get(api_url + `clients/${id}`, getConfig());
}

export async function getClientByCode(organisationId, code) {
  return axios.get(
    api_url + `clients/organisation/${organisationId}/code/${code}`,
    getConfig(),
  );
}

export async function createClient(data) {
  return axios.post(api_url + `clients`, data, getConfig());
}

export async function updateClient(id, data) {
  return axios.put(api_url + `clients/${id}`, data, getConfig());
}

export async function setDefaultClient(id) {
  return axios.put(api_url + `clients/${id}/set-default`, {}, getConfig());
}

export async function toggleBlockClient(id) {
  return axios.put(api_url + `clients/${id}/toggle-block`, {}, getConfig());
}

export async function deleteClient(id) {
  return axios.delete(api_url + `clients/${id}`, getConfig());
}

export const addClientDebit = (clientId, payload) => {
  return axios.post(`${api_url}/clients/${clientId}/credit/debit`, payload);
};

export const getClientCreditHistory = (clientId, params = {}) => {
  return axios.get(`${api_url}/clients/${clientId}/credit/history`, { params });
};
export const getClientOrders = (clientId, params = {}) => {
  return axios.get(`${api_url}/clients/${clientId}/orders`, {
    ...getConfig(),
    params,
  });
};
export const recordClientPayment = (clientId, payload) => {
  return axios.post(`${api_url}/clients/${clientId}/credit/payment`, payload);
};

export const getCreditSummary = (organisationId) => {
  return axios.get(
    api_url + `clients/organisation/${organisationId}/credit/summary`,
    getConfig(),
  );
};

export const getCreditSummaryPaginated = (organisationId, page = 1, limit = 20) => {
  return axios.get(
    api_url + `clients/organisation/${organisationId}/credit/summary`,
    { ...getConfig(), params: { page, limit } },
  );
};

export const getClientCreditEvolution = (organisationId, days = 30) => {
  return axios.get(
    api_url + `clients/organisation/${organisationId}/credit/evolution`,
    { ...getConfig(), params: { days } },
  );
};

export const getTopOrderClients = (organisationId, limit = 5) => {
  return axios.get(
    api_url + `clients/organisation/${organisationId}/top-orders`,
    { ...getConfig(), params: { limit } },
  );
};
